export default __webpack_public_path__ + "static/media/sponsor_footer_mx.7aff9eb8.svg";